"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentObject = exports.asHourMinSec = void 0;
var _number = require("../type-checks/number");
var _leadingCharacters = require("./leadingCharacters");
var getContentObject = exports.getContentObject = function getContentObject(_ref) {
  var hourAbbr = _ref.hourAbbr,
    hours = _ref.hours,
    minuteAbbr = _ref.minuteAbbr,
    minutes = _ref.minutes,
    secondAbbr = _ref.secondAbbr,
    seconds = _ref.seconds;
  var returnObj = {};
  if ((0, _number.isNumber)(hours)) {
    returnObj.hours = {
      abbr: hourAbbr || "hr",
      amount: hours,
      label: "Hour"
    };
  }
  if ((0, _number.isNumber)(minutes)) {
    returnObj.minutes = {
      abbr: minuteAbbr || "min",
      amount: minutes,
      label: "Minute"
    };
  }
  if ((0, _number.isNumber)(seconds)) {
    returnObj.seconds = {
      abbr: secondAbbr || "sec",
      amount: seconds,
      label: "Second"
    };
  }
  return returnObj;
};
var asHourMinSec = exports.asHourMinSec = function asHourMinSec(initialValue) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var duration = parseInt(initialValue, 10);
  var hours,
    minutes,
    seconds,
    returnTitle = "",
    returnValue = "";
  var returnElem = initialValue;
  var _config$leadingZeroes = config.leadingZeroes,
    leadingZeroes = _config$leadingZeroes === void 0 ? true : _config$leadingZeroes,
    _config$hourAbbr = config.hourAbbr,
    hourAbbr = _config$hourAbbr === void 0 ? "hr" : _config$hourAbbr,
    _config$minuteAbbr = config.minuteAbbr,
    minuteAbbr = _config$minuteAbbr === void 0 ? "min" : _config$minuteAbbr,
    _config$secondAbbr = config.secondAbbr,
    secondAbbr = _config$secondAbbr === void 0 ? "sec" : _config$secondAbbr,
    _config$requireHours = config.requireHours,
    requireHours = _config$requireHours === void 0 ? false : _config$requireHours,
    _config$requireMinute = config.requireMinutes,
    requireMinutes = _config$requireMinute === void 0 ? true : _config$requireMinute,
    _config$requireSecond = config.requireSeconds,
    requireSeconds = _config$requireSecond === void 0 ? true : _config$requireSecond,
    _config$separator = config.separator,
    separator = _config$separator === void 0 ? ":" : _config$separator,
    _config$valueOnly = config.valueOnly,
    valueOnly = _config$valueOnly === void 0 ? false : _config$valueOnly;
  if (!isNaN(duration) && (0, _number.isNumber)(duration)) {
    // Calculate hours, minutes, seconds;
    hours = Math.floor(duration / 3600);
    minutes = Math.floor((duration - hours * 3600) / 60);
    seconds = duration - hours * 3600 - minutes * 60;
    var contentObj;
    var contentObjData = {
      hourAbbr: hourAbbr,
      minuteAbbr: minuteAbbr,
      secondAbbr: secondAbbr
    };
    if (requireHours || hours > 0) {
      contentObjData.hours = hours;
    }
    if (requireMinutes || minutes > 0 || requireHours && minutes !== 0) {
      contentObjData.minutes = minutes;
    }
    if (requireSeconds || seconds > 0) {
      contentObjData.seconds = seconds;
    }
    contentObj = getContentObject(contentObjData);
    Object.keys(contentObj).forEach(function (key) {
      var targetValueAmount = (0, _leadingCharacters.leadingCharacters)(contentObj[key].amount, {
        minLength: leadingZeroes || !leadingZeroes && valueOnly ? 2 : 1
      });
      var targetTitleAmount = (0, _leadingCharacters.leadingCharacters)(contentObj[key].amount, {
        minLength: leadingZeroes ? 2 : 1
      });
      if (returnValue.length > 0) {
        returnValue += valueOnly ? separator : " ";
        returnTitle += " ";
      }
      returnValue += targetValueAmount;
      if (!valueOnly) {
        returnValue += " " + contentObj[key].abbr;
      }
      returnTitle += targetTitleAmount + " " + contentObj[key].label + (contentObj[key].amount === 1 ? "" : "s");
    });
    returnElem = {
      title: returnTitle,
      value: returnValue
    };
  }
  return returnElem;
};